/*
  Wolf Store cart feedback (2026-10-12)

  The theme has several separate scripts that add to cart (home cards, collection cards, product page,
  cross-sell, apps). Each one tried to update the cart counter on its own, and none of them could when the
  cart started empty, because the counter element is not in the page then.

  This file is the one place that:
    1. keeps every cart counter in step (header icon and bottom toolbar), whichever script changed the cart;
    2. shows one confirmation after an item is added, with a link to the cart;
    3. adds from the quick-add sheet without leaving the page.

  It watches cart requests instead of patching each script, so new sections and apps are covered too.
*/
(function () {
  if (window.WolfCart) return;

  var isAr = (document.documentElement.getAttribute('lang') || '').toLowerCase().indexOf('ar') === 0;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cartUrl = (window.routes && window.routes.cart_url) || root + 'cart';
  var nativeFetch = window.fetch ? window.fetch.bind(window) : null;
  var strings = isAr
    ? {
        added: 'أضيف إلى السلة',
        viewCart: 'عرض السلة',
        close: 'إغلاق',
        error: 'تعذرت الإضافة، حاول مرة أخرى',
      }
    : {
        added: 'Added to cart',
        viewCart: 'View cart',
        close: 'Close',
        error: 'Could not add this item. Please try again.',
      };

  var state = { count: null, toast: null, toastTimer: null, refreshTimer: null };

  /* ---------- counters ---------- */

  function isCartLink(href) {
    if (!href) return false;
    var path = href.split('?')[0].split('#')[0].replace(/\/+$/, '');
    return /\/cart$/.test(path);
  }

  function setCount(value) {
    var count = Number(value);
    if (!isFinite(count) || count < 0) return;
    var grew = state.count !== null && count > state.count;
    state.count = count;
    var label = count > 99 ? '99+' : String(count);

    var link = document.getElementById('cart-icon-bubble');
    if (link) {
      var bubble = link.querySelector('.cart-count-bubble');
      if (count > 0) {
        if (!bubble) {
          bubble = document.createElement('div');
          bubble.className = 'cart-count-bubble';
          link.appendChild(bubble);
        }
        var number = bubble.querySelector('span[aria-hidden="true"]');
        if (!number) {
          bubble.textContent = '';
          number = document.createElement('span');
          number.setAttribute('aria-hidden', 'true');
          bubble.appendChild(number);
        }
        number.textContent = label;
      } else if (bubble) {
        bubble.remove();
      }
    }

    document.querySelectorAll('.modern-toolbar-wrapper a.toolbar-link').forEach(function (anchor) {
      if (!isCartLink(anchor.getAttribute('href'))) return;
      var badge = anchor.querySelector('.wolf-cart-badge');
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'wolf-cart-badge';
          badge.setAttribute('aria-hidden', 'true');
          (anchor.querySelector('.modern-icon') || anchor).appendChild(badge);
        }
        badge.textContent = label;
        if (grew) {
          badge.classList.remove('is-bumped');
          void badge.offsetWidth;
          badge.classList.add('is-bumped');
        }
      } else if (badge) {
        badge.remove();
      }
    });
  }

  function refresh() {
    if (!nativeFetch) return;
    nativeFetch(root + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (cart) {
        if (cart && typeof cart.item_count === 'number') setCount(cart.item_count);
      })
      .catch(function () {});
  }

  /* ---------- confirmation ---------- */

  function buildToast() {
    var toast = document.createElement('div');
    toast.className = 'wolf-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');

    var image = document.createElement('img');
    image.className = 'wolf-toast__img';
    image.alt = '';
    image.width = 44;
    image.height = 44;

    var body = document.createElement('div');
    body.className = 'wolf-toast__body';

    var title = document.createElement('span');
    title.className = 'wolf-toast__title';
    title.innerHTML =
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
    var titleText = document.createElement('span');
    titleText.textContent = strings.added;
    title.appendChild(titleText);

    var name = document.createElement('span');
    name.className = 'wolf-toast__name';

    body.appendChild(title);
    body.appendChild(name);

    var link = document.createElement('a');
    link.className = 'wolf-toast__cta';
    link.href = cartUrl;
    link.textContent = strings.viewCart;

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'wolf-toast__close';
    close.setAttribute('aria-label', strings.close);
    close.innerHTML =
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg>';
    close.addEventListener('click', hideToast);

    toast.appendChild(image);
    toast.appendChild(body);
    toast.appendChild(link);
    toast.appendChild(close);

    toast.addEventListener('pointerenter', function () {
      clearTimeout(state.toastTimer);
    });
    toast.addEventListener('pointerleave', function () {
      state.toastTimer = setTimeout(hideToast, 2500);
    });

    document.body.appendChild(toast);
    return { el: toast, image: image, name: name };
  }

  /* On phones the confirmation sits just above whatever bar is fixed to the bottom of the screen. */
  function bottomOffset() {
    var offset = 12;
    var bars = document.querySelectorAll('.modern-toolbar-wrapper, .mobile-sticky-atc-wrapper:not(.is-hidden)');
    bars.forEach(function (bar) {
      var style = window.getComputedStyle(bar);
      if (style.display === 'none' || style.visibility === 'hidden') return;
      var rect = bar.getBoundingClientRect();
      if (!rect.height || rect.top < window.innerHeight - 220) return;
      offset = Math.max(offset, window.innerHeight - rect.top + 8);
    });
    return offset;
  }

  function hideToast() {
    clearTimeout(state.toastTimer);
    if (state.toast) state.toast.el.classList.remove('is-visible');
  }

  /* The product page may open its own offer popup right after an add; that popup carries the confirmation then. */
  function showToast(item) {
    if (/\/cart\/?$/.test(window.location.pathname)) return;
    setTimeout(function () {
      if (document.querySelector('.wolf-popup-overlay.is-visible')) return;
      renderToast(item);
    }, 150);
  }

  function renderToast(item) {
    if (!document.body) return;
    if (!state.toast) state.toast = buildToast();

    var toast = state.toast;
    var source = item && (item.image || (item.featured_image && item.featured_image.url));
    if (source) {
      toast.image.src = source + (source.indexOf('?') > -1 ? '&' : '?') + 'width=120';
      toast.image.hidden = false;
    } else {
      toast.image.removeAttribute('src');
      toast.image.hidden = true;
    }
    toast.name.textContent = (item && (item.product_title || item.title)) || '';
    toast.name.hidden = !toast.name.textContent;

    if (window.matchMedia('(max-width: 749px)').matches) {
      toast.el.style.bottom = bottomOffset() + 'px';
    } else {
      toast.el.style.bottom = '';
    }

    void toast.el.offsetWidth;
    toast.el.classList.add('is-visible');
    clearTimeout(state.toastTimer);
    state.toastTimer = setTimeout(hideToast, 5000);
  }

  /* ---------- watching cart requests ---------- */

  function cartPath(url) {
    try {
      return new URL(url, window.location.href).pathname;
    } catch (error) {
      return '';
    }
  }

  function isAddPath(path) {
    return /\/cart\/add(\.js)?$/.test(path);
  }

  function isCartStatePath(path) {
    return /\/cart(\.js|\/change(\.js)?|\/update(\.js)?|\/clear(\.js)?)$/.test(path);
  }

  function onAdded(data) {
    var item = data && data.items && data.items.length ? data.items[0] : data;
    showToast(item && typeof item === 'object' ? item : null);
    clearTimeout(state.refreshTimer);
    state.refreshTimer = setTimeout(refresh, 250);
  }

  function onCartState(cart) {
    if (cart && typeof cart.item_count === 'number') {
      clearTimeout(state.refreshTimer);
      setCount(cart.item_count);
    }
  }

  if (nativeFetch) {
    window.fetch = function (input, init) {
      var request = nativeFetch(input, init);
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
        var path = cartPath(url);
        if (isAddPath(path) && method === 'POST') {
          request
            .then(function (response) {
              if (!response.ok) return;
              response
                .clone()
                .json()
                .then(function (data) {
                  if (data && data.status && data.description) return;
                  onAdded(data);
                })
                .catch(function () {
                  onAdded(null);
                });
            })
            .catch(function () {});
        } else if (isCartStatePath(path)) {
          request
            .then(function (response) {
              if (!response.ok) return;
              response.clone().json().then(onCartState).catch(function () {});
            })
            .catch(function () {});
        }
      } catch (error) {}
      return request;
    };
  }

  /* Some apps still use XMLHttpRequest for the cart. */
  if (window.XMLHttpRequest) {
    var nativeOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      try {
        var path = cartPath(String(url));
        var verb = String(method || 'GET').toUpperCase();
        if ((isAddPath(path) && verb === 'POST') || isCartStatePath(path)) {
          var adding = isAddPath(path);
          this.addEventListener('load', function () {
            if (this.status < 200 || this.status >= 300) return;
            var data = null;
            try {
              data = JSON.parse(this.responseText);
            } catch (error) {}
            if (adding) onAdded(data);
            else onCartState(data);
          });
        }
      } catch (error) {}
      return nativeOpen.apply(this, arguments);
    };
  }

  /* ---------- quick-add sheet ---------- */

  /* The store accepts a form-encoded add even for a sold-out option or more than is in stock; the same add as JSON is
     checked against stock (422, or only what is left is added), so cards and the sheet send JSON and show its reply. */
  function jsonAddBody(formData) {
    var item = { id: Number(formData.get('id')), quantity: Number(formData.get('quantity')) || 1 };
    var properties = {};
    formData.forEach(function (value, key) {
      var match = key.match(/^properties\[(.+)\]$/);
      if (match) properties[match[1]] = value;
    });
    if (Object.keys(properties).length) item.properties = properties;
    if (formData.get('selling_plan')) item.selling_plan = Number(formData.get('selling_plan'));
    return JSON.stringify({ items: [item] });
  }

  function sheetError(modal, message) {
    if (!modal) {
      if (message) window.alert(message);
      return;
    }
    var wrapper = modal.querySelector('.product-form__error-message-wrapper');
    if (!wrapper) return;
    var text = wrapper.querySelector('.product-form__error-message');
    if (text) text.textContent = message;
    wrapper.hidden = !message;
  }

  /* Without this the theme's product form sends the shopper to the cart page after adding from a card or the sheet.
     Sections that already add in place stop the event before it gets here, so nothing is added twice. */
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.closest || !nativeFetch) return;
      var modal = form.closest('quick-add-modal');
      var card = form.closest('.quick-add');
      if ((!modal && !card) || !/\/cart\/add/.test(form.getAttribute('action') || '')) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      var button = form.querySelector('[type="submit"]');
      if (form.dataset.wolfBusy === 'true' || (button && button.getAttribute('aria-disabled') === 'true')) return;
      form.dataset.wolfBusy = 'true';
      if (button) button.classList.add('loading');
      var spinner = button && button.querySelector('.loading__spinner');
      if (spinner) spinner.classList.remove('hidden');
      sheetError(modal, '');

      window
        .fetch(root + 'cart/add.js', {
          method: 'POST',
          body: jsonAddBody(new FormData(form)),
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          credentials: 'same-origin',
        })
        .then(function (response) {
          return response.json().then(function (data) {
            return { ok: response.ok, data: data };
          });
        })
        .then(function (result) {
          if (!result.ok || (result.data && result.data.status && result.data.description)) {
            // A stock refusal can still add what is left, so the counters are re-read
            refresh();
            sheetError(modal, (result.data && (result.data.description || result.data.message)) || strings.error);
            return;
          }
          if (modal && typeof modal.hide === 'function') modal.hide(true);
        })
        .catch(function () {
          sheetError(modal, strings.error);
        })
        .then(function () {
          form.dataset.wolfBusy = 'false';
          if (button) button.classList.remove('loading');
          if (spinner) spinner.classList.add('hidden');
        });
    },
    true
  );

  /* ---------- start ---------- */

  function start() {
    if (typeof window.wolfCartCount === 'number') setCount(window.wolfCartCount);
    else refresh();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  /* A page restored from the back/forward cache can show an old count. */
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) refresh();
  });

  window.WolfCart = { setCount: setCount, refresh: refresh, showToast: showToast };
})();
